import { render, staticRenderFns } from "./TopBarLocaleChanger.vue?vue&type=template&id=3a8933b4"
import script from "./TopBarLocaleChanger.vue?vue&type=script&lang=js"
export * from "./TopBarLocaleChanger.vue?vue&type=script&lang=js"
import style0 from "./TopBarLocaleChanger.vue?vue&type=style&index=0&id=3a8933b4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports